module.exports = __webpack_public_path__ + "static/Futura-Medium-00ddb9fa17ff5362c1d4dce39a1b3817.otf";